import { useTranslation } from "react-i18next";
import StatusMessage from "../../../ui/feedback/StatusMessage";
import { FORM_HELP_TEXT_CLASS } from "../../../ui/styles/formStyles";
import type { RouteFit, TurnGap } from "./routeChoices";
import { gapsText } from "./routeFitText";

/**
 * Whether the chosen model can run the Thread's turns (Q-63), as the server checked it
 * against the facts and overrides it resolved (capabilities.md CAP-3). A capability no
 * fact states yet is a warning: the turns run and what the agent reports makes it known
 * (D17). One known to be lacking blocks.
 */
export default function RouteFitNotice({ fit, failed }: { fit: RouteFit; failed: boolean }) {
  const { t } = useTranslation();
  if (fit.kind !== "lacks" && fit.kind !== "uncertain") {
    const hint = failed ? "threads.hosting.fit.notChecked" : fit.kind === "fits" ? "threads.hosting.fit.fits" : "threads.hosting.capabilityHint";
    return <p className={FORM_HELP_TEXT_CLASS}>{t(hint)}</p>;
  }
  const byTurn = new Map<string | null, TurnGap[]>();
  for (const gap of fit.gaps) {
    byTurn.set(gap.stepKey, [...(byTurn.get(gap.stepKey) ?? []), gap]);
  }
  return (
    <StatusMessage tone="warning" title={t(fit.kind === "lacks" ? "threads.hosting.fit.lacksTitle" : "threads.hosting.fit.uncertainTitle")}>
      <ul className="list-disc space-y-0.5 pl-4">
        {[...byTurn].map(([stepKey, gaps]) => (
          <li key={stepKey ?? ""}>
            {stepKey === null ? t("threads.hosting.fit.replyTurns") : t("threads.hosting.fit.step", { step: stepKey })}: {gapsText(t, gaps)}
          </li>
        ))}
      </ul>
      {fit.gaps.some((gap) => gap.known === "unknown") ? <p className="mt-1">{t("threads.hosting.fit.unknownExplained")}</p> : null}
    </StatusMessage>
  );
}
